
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SatelliteLinkEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(4 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.fillStyle = pc.color;

        const drawSatellite = (x: number, y: number, s: number) => {
             ctx.save();
             ctx.translate(x, y);
             ctx.rotate(curTime * 0.1);
             
             // Body
             ctx.strokeRect(-s/2, -s/4, s, s/2);
             // Wings
             ctx.strokeRect(-s, -s/6, s/2, s/3);
             ctx.strokeRect(s/2, -s/6, s/2, s/3);
             
             // Signal beam
             if (Math.sin(curTime * 5 + x) > 0.5) {
                 ctx.save();
                 ctx.globalAlpha *= 0.3;
                 ctx.beginPath();
                 ctx.moveTo(0, 0);
                 ctx.lineTo(Math.sin(curTime) * 200, height * 2);
                 ctx.stroke();
                 ctx.restore();
             }
             ctx.restore();
        };

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const orbR = (300 + i * 150) * scale;
                const angle = curTime * (0.1 + i * 0.05) + i;
                const sx = Math.cos(angle) * orbR;
                const sy = Math.sin(angle) * orbR;
                
                drawSatellite(sx, sy, 40 * scale * (1 / (layerIndex + 1)));
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
